<template>
  <div id="farmsMap"></div>
</template>

<script>
import firebase from 'firebase/compat/app'

export default {
  mounted () {
    this.initMap()
  },
  methods: {
    initMap () {
      mapboxgl.accessToken = 'pk.eyJ1IjoibGVyZ3AiLCJhIjoiY2p4bmI1NzNzMGN0MTNjcGx4cjF4eDBtdSJ9.2C0FEHhNZ-jGd7jgIRTrEQ' // eslint-disable-line
      let map = new mapboxgl.Map({ // eslint-disable-line
        container: 'farmsMap',
        style: 'mapbox://styles/mapbox/satellite-v9',
        center: [-79, 0],
        zoom: 1
      })
      map.on('load', function () {
        const farmsGeoJsonStorageRef = firebase.storage().ref('statistics/farms/farms.geojson')
        farmsGeoJsonStorageRef.getDownloadURL().then(farmsGeoJsonUrl => {
          map.addSource('farmsSource', {
            type: 'geojson',
            data: farmsGeoJsonUrl
          })
          map.addLayer({
            id: 'farmsLayer',
            type: 'circle',
            source: 'farmsSource',
            layout: {},
            paint: {
              'circle-radius': 10,
              'circle-color': '#ffc107'
            }
          })
          // CLICK EVENTS
          map.on('click', 'farmsLayer', function (e) {
            var coordinates = e.features[0].geometry.coordinates.slice()
            // Open the farm as a simulated Administrator (super-admin view).
            // The ?simAs= query carries the role across the new tab so the
            // admin can interact with the farm; backend rules still enforce
            // real permissions. UI-only.
            var description = '<a href="/f/' + e.features[0].properties.id + '?simAs=Administrator" target="_blank" rel="noopener noreferrer">' + e.features[0].properties.name + '</a>'

            // Ensure that if the map is zoomed out such that multiple
            // copies of the feature are visible, the popup appears
            // over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
              coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
            }
            new mapboxgl.Popup().setLngLat(coordinates).setHTML(description).addTo(map) // eslint-disable-line
          })
          // MOUSE ENTER AND LEAVE POINTERS
          map.on('mouseenter', 'farmsLayer', function () {
            map.getCanvas().style.cursor = 'pointer'
          })
          map.on('mouseleave', 'farmsLayer', function () {
            map.getCanvas().style.cursor = ''
          })
        }) // axios response
      })
    }
  }
}
</script>

<style scoped>
#farmsMap {
  width: 100%;
  height: 550px;
  border-radius: 20px;
  color: black;
}
</style>
